/*
* Project: LegalPlace assistant
* File: src/redux/reducers/views.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import { PREVIEW_INDEX } from '../actions/views';

export default function viewsReducer(state = {}, action) {
  if (action.type === PREVIEW_INDEX) {
    const updatedState = state;
    const indexes = Object.keys(action.val);
    indexes.forEach((idx) => {
      updatedState[idx] = action.val[idx];
    });
    return updatedState;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/views.js